import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-open-stat',
  templateUrl: './form-open-stat.component.html',
  styleUrls: ['./form-open-stat.component.scss']
})
export class FormOpenStatComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
